// src/components/PublicRoute.js
import { Navigate } from 'react-router';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const PublicRoute = ({ children }) => {
  const { user, loading, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh'
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  // If authenticated and approved, redirect to dashboard
  if (isAuthenticated && user?.status === 'approved') {
    return <Navigate to="/dashboard" replace />;
  }

  // If authenticated but pending, redirect to pending page
  if (isAuthenticated && user?.status === 'pending') {
    return <Navigate to="/pending-approval" replace />;
  }

  // Otherwise, show the public page (login/register)
  return children;
};

export default PublicRoute;
